export default __webpack_public_path__ + "static/deer-0-3d8927b5e6f4901160126826666ac82f.png";